<template>
  <div class="behandelingen">
    <v-container class="text-left">
      <!-- PART ONEE -->
      <v-row class="my-md-10 my-3">
        <v-col cols="12"><h1 class="text-center red--text text--darken-2">Video reviews</h1></v-col>
        
        <v-col cols="12" class="col-sm-12 col-md-6">
          <h2 class="text-left grey--text text--darken-4">Aangezichtspijn</h2>
          <video width="100%" controls style="background-color: black;">
            <source src="@/assets/img/video/aangezicht.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </v-col>
        <v-col cols="12" class="col-sm-12 col-md-6">
          <h2 class="text-md-right text-sm-left grey--text text--darken-4">Aften</h2>
          <video width="100%" controls style="background-color: black;">
            <source src="@/assets/img/video/aften.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </v-col>
      </v-row>
      <hr>
      <!-- // PART TWOO -->
      <v-row class="my-10">
        <v-col cols="12" class="col-sm-12 col-md-6">
          <h2 class="text-left grey--text text--darken-4">Knieproblemen</h2>
          <video width="100%" controls style="background-color: black;">
            <source src="@/assets/img/video/knieproblemen.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </v-col>
        <v-col cols="12" class="col-sm-12 col-md-5 ml-md-15 ml-0">
          <h2 class="text-md-right text-sm-left grey--text text--darken-4">Accupunctuur</h2>
          <!-- <h2 class="text-right grey--text text--darken-4">??</h2>
          <video width="100%" controls>
            <source src="@/assets/img/video/lichamelijk-gehandicapt.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video> -->
            <v-row>
              <v-col cols="12" class="col-sm-12 col-md-6">
                <video width="80%" controls style="background-color: black;">
                    <source src="@/assets/img/man-behandel.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
              </v-col>
              <v-col cols="12" class="col-sm-12 col-md-6">
                <video width="80%" controls style="background-color: black;">
                    <source src="@/assets/img/vrouw-behandel.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
              </v-col>
            </v-row>
        </v-col>
      </v-row>
      <hr>
      <v-row class="my-10">
        <v-col cols="12" class="col-sm-12 col-md-6">
          <h2 class="text-left grey--text text--darken-4">Rugbehandeling</h2>
          <video width="100%" controls style="background-color: black;">
            <source src="@/assets/img/video/rugbehandeling.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </v-col>
        <v-col cols="12" class="col-sm-12 col-md-6">
          <h2 class="text-md-right text-sm-left grey--text text--darken-4">Stoppen met roken</h2>
          <video width="100%" controls style="background-color: black;">
            <source src="@/assets/img/video/stoppen-roken.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </v-col>
      </v-row>
      <hr>
      <v-row class="my-10">
        <v-col cols="12" class="col-sm-12 col-md-6">
          <h2 class="text-left grey--text text--darken-4">Algemene gezondheid</h2>
          <video width="100%" controls style="background-color: black;">
            <source src="@/assets/img/video/156.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </v-col>
        <v-col cols="12" class="col-sm-12 col-md-6">
          <h2 class="text-md-right text-sm-left grey--text text--darken-4">Migraine</h2>
          <video width="100%" controls style="background-color: black;">
            <source src="@/assets/img/video/157.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col>
          <p>Alle cliënten in deze video's hebben toestemming gegeven voor publicatie.</p>
        </v-col>
      </v-row>



    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  }
}
</script>
